export const NotificationTypeEnum = {
    CERTIFICATE_EXPIRED: "certificate_expired",
    CERTIFICATE_ADDED: "certificate_added",
    WARNING_RED: "warning-red",
};

export type NotificationType = keyof typeof NotificationTypeEnum;
